import { ConflictApiError } from '../api-client'

export function isErrorConflict(error: Error): error is ConflictApiError {
  return error instanceof ConflictApiError
}
